"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImageService = exports.ImageServiceContextProvider = void 0;
const react_1 = __importDefault(require("react"));
const ImageContainer_1 = require("./components/ImageContainer/ImageContainer");
const ImageComponent = (_a) => {
    var { src, altText, height, width } = _a, rest = __rest(_a, ["src", "altText", "height", "width"]);
    // Use the image service context to get the service URL and enhancement settings
    return (react_1.default.createElement(ImageContainer_1.ImageContainer, Object.assign({ src: src, alt: altText, height: height, width: width }, rest)));
};
exports.default = ImageComponent;
// Export provider and related types
var ImageServiceProvider_1 = require("./providers/ImageServiceProvider");
Object.defineProperty(exports, "ImageServiceContextProvider", { enumerable: true, get: function () { return ImageServiceProvider_1.ImageServiceContextProvider; } });
var useImageServiceHook_1 = require("./hooks/useImageServiceHook");
Object.defineProperty(exports, "useImageService", { enumerable: true, get: function () { return useImageServiceHook_1.useImageService; } });
//# sourceMappingURL=index.js.map